import { render, staticRenderFns } from "./sns.vue?vue&type=template&id=c1708aa4&scoped=true&"
import script from "./sns.vue?vue&type=script&lang=js&"
export * from "./sns.vue?vue&type=script&lang=js&"
import style0 from "./sns.vue?vue&type=style&index=0&id=c1708aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1708aa4",
  null
  
)

export default component.exports